// [C217] Presentation slots only: ordering never changes canon priorities.
export const SLOT_STORAGE_KEY = "lifttech.showcase.slotMap.v1";
export const SLOT_DEFINITIONS = [
  { id: "top-row-left", label: "Top left", product: "noticeboard" },
  { id: "top-row-center", label: "Top centre", product: "remote-screens" },
  { id: "top-row-right", label: "Top right", product: "website" },
  { id: "middle-left", label: "Left side", product: "operations-console" },
  { id: "middle-right", label: "Right side", product: "customer-portal" },
  { id: "bottom-row-left", label: "Bottom left", product: "emergency-comms" },
  { id: "bottom-row-center", label: "Bottom centre", product: "call-centre" },
  { id: "bottom-row-right", label: "Bottom right", product: "elevator-intelligence" },
  { id: "bottom-row-far-right", label: "Bottom far right", product: "top-of-car" },
];
export const DEFAULT_SLOT_MAP = Object.fromEntries(SLOT_DEFINITIONS.map((slot) => [slot.id, slot.product]));
export const validSlotMap = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const values = Object.values(value);
  return Object.keys(value).length === SLOT_DEFINITIONS.length &&
    new Set(values).size === SLOT_DEFINITIONS.length &&
    SLOT_DEFINITIONS.every((slot) => Object.hasOwn(value, slot.id) && values.includes(slot.product));
};
export const readSlotMap = () => {
  try {
    const raw = localStorage.getItem(SLOT_STORAGE_KEY);
    if (!raw) return { slots: DEFAULT_SLOT_MAP, message: "Starting layout · changes save on this browser", error: false };
    const value = JSON.parse(raw);
    if (value.schemaVersion !== 1 || !validSlotMap(value.slots)) throw new Error("Invalid saved layout");
    return { slots: value.slots, message: "Saved layout · this browser", error: false };
  } catch (error) {
    return { slots: DEFAULT_SLOT_MAP, message: "Saved layout unavailable. Using the starting layout.", error: true };
  }
};
